import type { AxiosError } from "axios";

type ApiErrorBody = {
  error?: string;
  message?: string;
  details?: string;
  required?: string;
};

export function getApiErrorMessage(
  error: unknown,
  fallback: string,
): string {
  const axiosError = error as AxiosError<ApiErrorBody>;
  const status = axiosError?.response?.status;
  const body = axiosError?.response?.data;

  if (status === 401) {
    return "Your session expired. Sign in again and retry.";
  }

  if (status === 403) {
    if (body?.required) {
      return `You do not have permission for this report (${body.required}). Ask an administrator to grant analytics access.`;
    }
    return (
      body?.message ||
      "You do not have permission to view this report for your organization."
    );
  }

  if (status === 503) {
    return (
      body?.message ||
      "Analytics storage is unavailable in this environment. Contact your administrator."
    );
  }

  if (typeof body?.message === "string" && body.message.trim()) {
    return body.message;
  }

  if (typeof body?.error === "string" && body.error.trim()) {
    return body.error;
  }

  if (typeof body?.details === "string" && body.details.trim()) {
    return body.details;
  }

  if (axiosError?.message === "Network Error") {
    return "Unable to reach the API. Check that the backend is running and retry.";
  }

  return fallback;
}
